<template>
  <div class="candidate-home vacancies">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2 class="mb-4">Вакансії</h2>
        </div>
        <div class="col-12">
          <b-tabs content-class="mt-3" pills>
            <b-tab title="Усі" active>
              <vacanciesTab />
            </b-tab>
            <b-tab>
              <template #title>
                <b-icon-star-fill />
                Збережені
              </template>
              <favouriteVacanciesTab ref="favourites" />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vacanciesTab from "./tabs/vacancies-tab.vue";
import favouriteVacanciesTab from "./tabs/favourite-vacancies-tab.vue";
export default {
  components: {
    vacanciesTab,
    favouriteVacanciesTab,
  },
  computed: {
    user() {
      return this.$store.state.userData;
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.vacancies {
  .tabs {
    a.nav-link {
      &.active {
        background: var(--primary-color);
      }
    }
  }
}
</style>
